module.exports = __webpack_public_path__ + "static/nachalo+-42501a153202504a9cf01a5f0ef487c9.svg";